import Button from 'src/components/buttons/button';
import { SeeMoreResults } from 'styles-js/resultsList';
const MAX_PAGE_SIZE = 30;
type Props = {
  items: unknown[];
  label: string;
  onShowMore: (pageNumber: number) => void;
};
export default function ShowMoreResults({
  items,
  label,
  onShowMore
}: Props) {
  if (!items?.length) return null;

  // we show max 30 posts "per page" - or rather, max 30 posts get fetched from the backend
  // if current post quantity is divisible by the max page size without remainder => there are most likely more posts to be fetched for the userId, eg 60
  // if current post quantity has a remainder, e.g. 35, the last fetch returned only 5 instead of the full 30, hence no more posts were found for the userId
  const showHasMoreResults = items.length !== 0 && items.length % MAX_PAGE_SIZE === 0;
  const onShowMoreClick = () => {
    const pageNumber = Math.floor(items?.length / MAX_PAGE_SIZE) + 1;
    onShowMore(pageNumber);
  };
  return <>
      {showHasMoreResults && <SeeMoreResults id="show-more-results">
          <Button fullWidth={true} type="secondary" onClick={onShowMoreClick}>
            {label}
          </Button>
        </SeeMoreResults>}
    </>;
}